import { AppState } from 'src/app/store'
import { CompleteInfoPayload } from 'src/core/models'
import { extractFormData, getFileFromBlobUrl } from 'src/core/helpers'

export const restorePasswordSelector = (state: AppState) => state.auth.restorePassword
export const forgotPasswordSelector = (state: AppState) => state.auth.forgotPassword
export const credentialsRegisterSelector = (state: AppState) => state.auth.register.credentials
export const personalDetailsRegisterSelector = (state: AppState) => state.auth.register.personalDetails
export const authRolSelector = (state: AppState) => state.auth.register.rol
export const loginAuthSelector = (state: AppState) => state.auth.login
export const verifyEmailSelector = (state: AppState) => state.auth.verifyEmail
export const completeInfoFormStep = (state: AppState) => state.auth.completeInfo.step
export const completeInfoConfirmSellerRolSelector = (state: AppState) => state.auth.completeInfo.confirmSellerRol
export const completeInfoStateSelector = (state: AppState) => state.auth.completeInfo
export const completeInfoSubmitSelector = (state: AppState) => state.auth.completeInfoSubmit
export const verifyTokenSelector = (state: AppState) => state.auth.verifyToken

export const completeInfoStatePayloadSelector = async (state: AppState): Promise<CompleteInfoPayload> => {
  const data = state.auth.completeInfo

  try {  // Company Files
    const filesConverted = {
      representative_id_document: data.identityDocument ?  await getFileFromBlobUrl(data.identityDocument) : '',
      power_of_attorney_document: data.powerOfAttorney ? await getFileFromBlobUrl(data.powerOfAttorney) : '',
      vat_number_document: data.companyDocumentation ? await getFileFromBlobUrl(data.companyDocumentation) : '',
    }
    const filesData = extractFormData(filesConverted)
    return {
      userValues: {
        is_producer: data.confirmSellerRol,
        reason_to_register: data.reasonToRegister,
        company_position: data.companyPosition
      },
      companyFiles: { filesData }
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(error)
  }
}
